import { Status } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { SMS } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { OptimisticUpdateStatusDetails } from './types';

export const SENDING_STATUS_DATA: Pick<SMS, 'status' | 'statusDetails'> = {
  status: Status.STATUS_NOT_SENT,
  statusDetails: OptimisticUpdateStatusDetails.SENDING,
} as const;
